var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.vdropzoneOptions)?_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.vdropzoneOptions},on:{"vdropzone-success":_vm.vsuccess}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }